import http from './http'

export default {
  login(email, password, rememberMe = false) {
    return http.post('/auth/v1/login', { email, password, rememberMe })
  },
  logout() {
    return http.post('/auth/v1/logout')
  },
  register(payload) {
    return http.post('/auth/v1/register', payload)
  },
  forgotPassword(email) {
    return http.post('/auth/v1/forgot-password', { email })
  },
  resetPassword(token, password) {
    return http.post('/auth/v1/reset-password', { token, password })
  },
  me() {
    return http.get('/auth/v1/me')
  },
  setTimezone(timezone) {
    return http.post('/auth/v1/timezone', { timezone })
  },
}
